(function () {
  'use strict';

  if (window.UnifiedMetaProvider) {
    return;
  }

  const VERSION = '1.2.0';
  const PROVIDER_ID = 'meta';

  const META_LIBRARY_URL =
    'https://connect.facebook.net/en_US/fbevents.js';

  const META_LIBRARY_ID =
    'unified-meta-pixel-library';

  let pixelInitialized = false;
  let pageViewSent = false;
  let privacyApiLoadRequested = false;
  let lastEventId = '';

  function getConfig() {
    return (
      window.UnifiedTrackingConfig ||
      {}
    );
  }

  function getMetaConfig() {
    const config = getConfig();

    const providers =
      config.providers || {};

    const source =
      providers.meta;

    if (
      source &&
      typeof source === 'object' &&
      !Array.isArray(source)
    ) {
      return source;
    }

    return {
      enabled:
        source === true
    };
  }

  function isEnabled() {
    const source =
      getMetaConfig();

    return (
      source.enabled === true
    );
  }

  function getPixelId() {
    const source =
      getMetaConfig();

    const value =
      source.pixelId ||
      source.pixel_id ||
      '';

    return String(
      value
    ).trim();
  }

  function isValidPixelId(
    pixelId
  ) {
    return /^\d+$/.test(
      String(
        pixelId || ''
      )
    );
  }

  function isConsentRequired() {
    return (
      getConfig()
        .consentRequired ===
      true
    );
  }

  function isDebugEnabled() {
    return (
      getConfig().debug ===
      true
    );
  }

  function debugLog(
    message,
    data
  ) {
    if (!isDebugEnabled()) {
      return;
    }

    console.info(
      '[Unified Meta Provider] ' +
        message,
      data || {}
    );
  }

  function reportError(
    code,
    message,
    details
  ) {
    if (
      window.UnifiedErrors &&
      typeof window.UnifiedErrors
        .report === 'function'
    ) {
      window.UnifiedErrors
        .report(
          'warning',
          code,
          message,
          details || {}
        );

      return;
    }

    console.warn(
      '[Unified Meta Provider] ' +
        message,
      details || {}
    );
  }

  function getCustomerPrivacyApi() {
    if (
      window.Shopify &&
      window.Shopify
        .customerPrivacy
    ) {
      return (
        window.Shopify
          .customerPrivacy
      );
    }

    return null;
  }

  function hasMarketingConsent() {
    if (!isConsentRequired()) {
      return true;
    }

    const privacyApi =
      getCustomerPrivacyApi();

    if (
      !privacyApi ||
      typeof privacyApi
        .marketingAllowed !==
        'function'
    ) {
      return false;
    }

    try {
      return (
        privacyApi
          .marketingAllowed() ===
        true
      );
    } catch (error) {
      reportError(
        'meta_marketing_consent_check_failed',
        'Marketing consent check failed.',
        {
          error:
            error.message
        }
      );

      return false;
    }
  }

  function installFbqStub() {
    if (
      typeof window.fbq ===
      'function'
    ) {
      return window.fbq;
    }

    const fbq =
      function () {
        if (fbq.callMethod) {
          fbq.callMethod
            .apply(
              fbq,
              arguments
            );
        } else {
          fbq.queue.push(
            arguments
          );
        }
      };

    if (!window._fbq) {
      window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    window.fbq = fbq;

    return fbq;
  }

  function ensureMetaLibrary() {
    installFbqStub();

    const existingById =
      document.getElementById(
        META_LIBRARY_ID
      );

    if (existingById) {
      return true;
    }

    const scripts =
      document
        .getElementsByTagName(
          'script'
        );

    for (
      let index = 0;
      index < scripts.length;
      index += 1
    ) {
      const src =
        String(
          scripts[index].src ||
          ''
        );

      if (
        src.indexOf(
          'connect.facebook.net'
        ) !== -1 &&
        src.indexOf(
          'fbevents.js'
        ) !== -1
      ) {
        return true;
      }
    }

    const script =
      document.createElement(
        'script'
      );

    script.id =
      META_LIBRARY_ID;

    script.async = true;

    script.src =
      META_LIBRARY_URL;

    const firstScript =
      document
        .getElementsByTagName(
          'script'
        )[0];

    if (
      firstScript &&
      firstScript.parentNode
    ) {
      firstScript
        .parentNode
        .insertBefore(
          script,
          firstScript
        );
    } else if (
      document.head
    ) {
      document.head
        .appendChild(
          script
        );
    } else {
      return false;
    }

    return true;
  }

  function grantMetaConsent() {
    if (
      typeof window.fbq !==
      'function'
    ) {
      return false;
    }

    try {
      window.fbq(
        'consent',
        'grant'
      );

      return true;
    } catch (error) {
      reportError(
        'meta_consent_grant_failed',
        'Meta consent grant failed.',
        {
          error:
            error.message
        }
      );

      return false;
    }
  }

  function revokeMetaConsent() {
    if (
      typeof window.fbq !==
      'function'
    ) {
      return true;
    }

    try {
      window.fbq(
        'consent',
        'revoke'
      );

      debugLog(
        'Meta consent revoked'
      );

      return true;
    } catch (error) {
      reportError(
        'meta_consent_revoke_failed',
        'Meta consent revoke failed.',
        {
          error:
            error.message
        }
      );

      return false;
    }
  }

  function shouldSendPageView() {
    const source =
      getMetaConfig();

    return (
      source.pageView !==
      false
    );
  }

  function sendPageView() {
    if (
      pageViewSent ||
      !shouldSendPageView() ||
      typeof window.fbq !==
        'function'
    ) {
      return false;
    }

    const pixelId =
      getPixelId();

    if (
      !isValidPixelId(
        pixelId
      )
    ) {
      return false;
    }

    try {
      window.fbq(
        'trackSingle',
        pixelId,
        'PageView'
      );

      pageViewSent = true;

      debugLog(
        'Meta PageView queued',
        {
          pixelId:
            pixelId,

          pagePath:
            window.location
              .pathname
        }
      );

      return true;
    } catch (error) {
      reportError(
        'meta_page_view_failed',
        'Meta PageView failed.',
        {
          error:
            error.message
        }
      );

      return false;
    }
  }

  function ensureInitialized() {
    if (!isEnabled()) {
      return {
        success: false,

        code:
          'meta_disabled',

        message:
          'Meta provider is disabled.'
      };
    }

    const pixelId =
      getPixelId();

    if (
      !isValidPixelId(
        pixelId
      )
    ) {
      return {
        success: false,

        code:
          'meta_pixel_id_invalid',

        message:
          'Meta Pixel ID is missing or invalid.'
      };
    }

    if (
      !hasMarketingConsent()
    ) {
      return {
        success: false,

        code:
          'meta_marketing_consent_missing',

        message:
          'Marketing consent is required for Meta.'
      };
    }

    if (
      !ensureMetaLibrary()
    ) {
      return {
        success: false,

        code:
          'meta_library_load_failed',

        message:
          'Meta Pixel library could not be loaded.'
      };
    }

    grantMetaConsent();

    if (!pixelInitialized) {
      try {
        window.fbq(
          'init',
          pixelId
        );

        pixelInitialized = true;

        debugLog(
          'Meta Pixel initialized',
          {
            pixelId:
              pixelId
          }
        );
      } catch (error) {
        return {
          success: false,

          code:
            'meta_pixel_init_failed',

          message:
            error.message
        };
      }
    }

    sendPageView();

    return {
      success: true,
      pixelId:
        pixelId
    };
  }

  function getEventMap() {
    const source =
      getMetaConfig();

    const configured =
      source.eventMap ||
      source.event_map ||
      {};

    return Object.assign(
      {
        phone_grooming:
          'Lead',

        phone_hotel:
          'Lead',

        phone_veterinar:
          'Lead',

        email_hotel:
          'Lead',

        contact_form_submit:
          'Lead'
      },

      configured &&
      typeof configured ===
        'object' &&
      !Array.isArray(
        configured
      )
        ? configured
        : {}
    );
  }

  function resolveMetaEvent(
    eventName
  ) {
    const map =
      getEventMap();

    const mapped =
      map[eventName];

    if (
      typeof mapped !==
        'string' ||
      !mapped.trim()
    ) {
      return '';
    }

    return mapped.trim();
  }

  function projectPayload(
    eventName,
    payload
  ) {
    const source =
      payload &&
      typeof payload ===
        'object'
        ? payload
        : {};

    const projected = {
      ut_event_name:
        eventName
    };

    if (
      typeof source.service ===
        'string' &&
      source.service
    ) {
      projected.service =
        source.service;
    }

    if (
      typeof source
        .event_category ===
        'string' &&
      source.event_category
    ) {
      projected.event_category =
        source.event_category;
    }

    if (
      typeof source
        .page_path ===
        'string' &&
      source.page_path
    ) {
      projected.page_path =
        source.page_path;
    }

    return projected;
  }

  function getEventId(
    context
  ) {
    const source =
      context &&
      typeof context ===
        'object' &&
      !Array.isArray(context)
        ? context
        : {};

    const metadata =
      source.metadata &&
      typeof source.metadata ===
        'object' &&
      !Array.isArray(
        source.metadata
      )
        ? source.metadata
        : {};

    const value =
      metadata.event_id ||
      metadata.eventId ||
      source.event_id ||
      source.eventId ||
      '';

    return String(
      value || ''
    ).trim();
  }

  function getCapiClient() {
    const client =
      window.UnifiedCapiClient;

    if (
      !client ||
      typeof client !==
        'object'
    ) {
      return null;
    }

    return client;
  }

  function getCapiStatus() {
    const client =
      getCapiClient();

    if (
      !client ||
      typeof client
        .getStatus !==
        'function'
    ) {
      return null;
    }

    try {
      return (
        client.getStatus() ||
        null
      );
    } catch (error) {
      reportError(
        'meta_capi_status_failed',
        'CAPI client status could not be read.',
        {
          error:
            error.message
        }
      );

      return null;
    }
  }

  function queueCapiSidecar(
    metaEvent,
    eventName,
    payload,
    context,
    eventId
  ) {
    if (!eventId) {
      return false;
    }

    const client =
      getCapiClient();

    if (
      !client ||
      typeof client.send !==
        'function'
    ) {
      reportError(
        'meta_capi_client_unavailable',
        'CAPI client is unavailable.',
        {
          event:
            eventName,

          meta_event:
            metaEvent,

          event_id:
            eventId
        }
      );

      return false;
    }

    let pending;

    try {
      pending =
        client.send(
          metaEvent,
          eventName,
          payload,
          context
        );
    } catch (error) {
      reportError(
        'meta_capi_dispatch_failed',
        'CAPI sidecar could not be started.',
        {
          event:
            eventName,

          meta_event:
            metaEvent,

          event_id:
            eventId,

          error:
            error.message
        }
      );

      return false;
    }

    Promise.resolve(
      pending
    )
      .then(
        function (result) {
          if (
            result &&
            result.success ===
              true
          ) {
            debugLog(
              'CAPI sidecar completed',
              {
                event:
                  eventName,

                metaEvent:
                  metaEvent,

                eventId:
                  eventId,

                forwarded:
                  result.forwarded ===
                  true,

                duplicate:
                  result.duplicate ===
                  true,

                httpStatus:
                  result.http_status ||
                  0
              }
            );

            return;
          }

          reportError(
            'meta_capi_dispatch_rejected',
            'CAPI sidecar did not complete successfully.',
            {
              event:
                eventName,

              meta_event:
                metaEvent,

              event_id:
                eventId,

              code:
                result &&
                result.code
                  ? result.code
                  : '',

              http_status:
                result &&
                result.http_status
                  ? result.http_status
                  : 0
            }
          );
        }
      )
      .catch(
        function (error) {
          reportError(
            'meta_capi_dispatch_failed',
            'CAPI sidecar failed asynchronously.',
            {
              event:
                eventName,

              meta_event:
                metaEvent,

              event_id:
                eventId,

              error:
                error &&
                error.message
                  ? error.message
                  : String(error)
            }
          );
        }
      );

    debugLog(
      'CAPI sidecar queued',
      {
        event:
          eventName,

        metaEvent:
          metaEvent,

        eventId:
          eventId
      }
    );

    return true;
  }

  function send(
    eventName,
    payload,
    context
  ) {
    const metaEvent =
      resolveMetaEvent(
        eventName
      );

    if (!metaEvent) {
      return {
        success: false,

        code:
          'meta_event_unmapped',

        message:
          'Event is not mapped to a Meta event.'
      };
    }

    const initialized =
      ensureInitialized();

    if (
      !initialized.success
    ) {
      return initialized;
    }

    const pixelId =
      initialized.pixelId;

    const eventId =
      getEventId(
        context
      );

    const metaPayload =
      projectPayload(
        eventName,
        payload
      );

    let capiQueued = false;

    try {
      if (eventId) {
        window.fbq(
          'trackSingle',
          pixelId,
          metaEvent,
          metaPayload,
          {
            eventID:
              eventId
          }
        );

        lastEventId =
          eventId;

        capiQueued =
          queueCapiSidecar(
            metaEvent,
            eventName,
            payload,
            context,
            eventId
          );
      } else {
        window.fbq(
          'trackSingle',
          pixelId,
          metaEvent,
          metaPayload
        );

        lastEventId = '';

        reportError(
          'meta_event_id_missing',
          'Meta browser event was sent without an event ID.',
          {
            event:
              eventName,

            meta_event:
              metaEvent
          }
        );
      }

      debugLog(
        'Meta event queued',
        {
          event:
            eventName,

          metaEvent:
            metaEvent,

          pixelId:
            pixelId,

          eventId:
            eventId,

          capiQueued:
            capiQueued
        }
      );

      return {
        success: true,

        transport:
          'meta_pixel',

        pixel_id:
          pixelId,

        meta_event:
          metaEvent,

        event_id:
          eventId,

        capi_queued:
          capiQueued
      };
    } catch (error) {
      return {
        success: false,

        code:
          'meta_send_failed',

        message:
          error.message
      };
    }
  }

  function isAvailable() {
    return (
      isEnabled() &&
      isValidPixelId(
        getPixelId()
      ) &&
      typeof document !==
        'undefined'
    );
  }

  function syncConsentState(
    source
  ) {
    if (!isEnabled()) {
      return false;
    }

    if (
      hasMarketingConsent()
    ) {
      const result =
        ensureInitialized();

      debugLog(
        'Consent state synchronized',
        {
          source:
            source || '',

          marketingAllowed:
            true,

          initialized:
            result.success ===
            true
        }
      );

      return (
        result.success ===
        true
      );
    }

    revokeMetaConsent();

    debugLog(
      'Consent state synchronized',
      {
        source:
          source || '',

        marketingAllowed:
          false,

        initialized:
          pixelInitialized
      }
    );

    return false;
  }

  function ensurePrivacyApi(
    callback
  ) {
    if (
      !isConsentRequired()
    ) {
      callback();
      return;
    }

    if (
      getCustomerPrivacyApi()
    ) {
      callback();
      return;
    }

    if (
      privacyApiLoadRequested
    ) {
      return;
    }

    privacyApiLoadRequested =
      true;

    if (
      window.Shopify &&
      typeof window.Shopify
        .loadFeatures ===
        'function'
    ) {
      window.Shopify
        .loadFeatures(
          [
            {
              name:
                'consent-tracking-api',

              version:
                '0.1'
            }
          ],

          function (error) {
            if (error) {
              reportError(
                'meta_privacy_api_load_failed',
                'Shopify Customer Privacy API could not be loaded.',
                {
                  error:
                    String(error)
                }
              );

              return;
            }

            callback();
          }
        );

      return;
    }

    reportError(
      'meta_privacy_api_unavailable',
      'Shopify Customer Privacy API is unavailable.',
      {}
    );
  }

  function handleConsentChange(
    event
  ) {
    const detail =
      event &&
      event.detail &&
      typeof event.detail ===
        'object'
        ? event.detail
        : {};

    if (
      typeof detail
        .marketingAllowed ===
        'boolean'
    ) {
      if (
        detail.marketingAllowed
      ) {
        ensurePrivacyApi(
          function () {
            syncConsentState(
              'visitorConsentCollected'
            );
          }
        );
      } else {
        revokeMetaConsent();
      }

      return;
    }

    ensurePrivacyApi(
      function () {
        syncConsentState(
          'visitorConsentCollected'
        );
      }
    );
  }

  function getStatus() {
    const capiStatus =
      getCapiStatus();

    return {
      version:
        VERSION,

      enabled:
        isEnabled(),

      pixel_id:
        getPixelId(),

      pixel_initialized:
        pixelInitialized,

      page_view_sent:
        pageViewSent,

      marketing_allowed:
        hasMarketingConsent(),

      fbq_available:
        typeof window.fbq ===
        'function',

      last_event_id:
        lastEventId,

      capi_loaded:
        Boolean(
          getCapiClient()
        ),

      capi_status:
        capiStatus
    };
  }

  const manager =
    window.UnifiedProviderManager;

  if (
    !manager ||
    typeof manager
      .registerProvider !==
      'function'
  ) {
    reportError(
      'meta_provider_manager_unavailable',
      'Unified Provider Manager is unavailable.',
      {}
    );

    return;
  }

  const registration =
    manager.registerProvider(
      PROVIDER_ID,

      {
        isAvailable:
          isAvailable,

        send:
          send
      },

      {
        name:
          'Meta Pixel',

        priority:
          900,

        metadata: {
          built_in:
            false,

          transport:
            'meta_pixel',

          capi_sidecar:
            true,

          version:
            VERSION
        }
      }
    );

  if (
    registration.success !==
    true
  ) {
    reportError(
      'meta_provider_registration_failed',
      'Meta provider could not be registered.',
      registration
    );

    return;
  }

  document.addEventListener(
    'visitorConsentCollected',
    handleConsentChange
  );

  window.UnifiedMetaProvider = {
    version:
      VERSION,

    id:
      PROVIDER_ID,

    getStatus:
      getStatus,

    hasMarketingConsent:
      hasMarketingConsent,

    ensureInitialized:
      ensureInitialized,

    syncConsentState:
      syncConsentState
  };

  if (isEnabled()) {
    ensurePrivacyApi(
      function () {
        syncConsentState(
          'initial'
        );
      }
    );
  }

  debugLog(
    'Meta provider initialized',
    getStatus()
  );
})();
